export default function(value) {
  if (typeof(value) === 'number' ){
    return `${value}%`;
  } else{
    return `${value}`;
  }
}


// WEBPACK FOOTER //
// ./src/modules/dro/filters/percent.js